import { Injectable } from '@angular/core';
import { WIDGETS_FLAG } from '@rms/core/feature-flags';
import { Sections } from '@rms/org';
import { BehaviorSubject, Observable } from 'rxjs';

import { NavigationItem } from './navigation-item.interface';

@Injectable({
  providedIn: 'root',
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> = new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor() {
    this.loadNavigation();
  }

  loadNavigation(): void {
    this._items.next([
      {
        type: 'link',
        label: 'menu.home',
        route: '/home',
        restricted: false,
        icon: 'remix:Buildings/home-smile-2-line',
        hoverIcon: 'remix:Buildings/home-smile-2-fill',
        routerLinkActiveOptions: { exact: true },
      },
      {
        type: 'link',
        label: 'menu.phone-system',
        route: '/phone-system',
        section: Sections.PhoneSystem,
        restricted: false,
        icon: 'remix:Device/phone-line',
        hoverIcon: 'remix:Device/phone-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.calls',
        route: '/calls',
        section: Sections.Calls,
        restricted: false,
        icon: 'remix:Device/server-line',
        hoverIcon: 'remix:Device/server-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.analytics',
        route: '/call-analytics',
        section: Sections.Calls,
        restricted: false,
        icon: 'remix:Business/bar-chart-2-line',
        hoverIcon: 'remix:Business/bar-chart-2-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.team',
        route: '/team',
        section: Sections.Team,
        restricted: false,
        icon: 'remix:User & Faces/team-line',
        hoverIcon: 'remix:User & Faces/team-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.agents',
        route: '/agents',
        section: Sections.Agents,
        restricted: false,
        icon: 'remix:Logos/bard-line',
        hoverIcon: 'remix:Logos/bard-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.call-campaigns',
        route: '/call-campaigns',
        section: Sections.CallCampaigns,
        restricted: false,
        icon: 'remix:Communication/speak-ai-line',
        hoverIcon: 'remix:Communication/speak-ai-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.contacts',
        route: '/contacts',
        section: Sections.Contacts,
        restricted: false,
        icon: 'remix:Document/contacts-book-2-line',
        hoverIcon: 'remix:Document/contacts-book-2-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.inbox',
        route: '/inbox',
        section: Sections.Inbox,
        restricted: true,
        icon: 'remix:Business/inbox-line',
        hoverIcon: 'remix:Business/inbox-fill',
        routerLinkActiveOptions: { exact: true },
      },
      {
        type: 'link',
        label: 'menu.sms',
        route: '/sms',
        restricted: false,
        icon: 'remix:Communication/chat-1-line',
        hoverIcon: 'remix:Communication/chat-1-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.knowledge-base',
        route: '/knowledge-base',
        section: Sections.KnowledgeBase,
        restricted: false,
        icon: 'remix:Document/book-3-line',
        hoverIcon: 'remix:Document/book-3-fill',
        routerLinkActiveOptions: { exact: false },
      },
      // TODO: Set restricted to false when ready to release
      {
        type: 'link',
        label: 'menu.webhooks',
        route: '/webhooks',
        section: Sections.Webhooks,
        restricted: true,
        icon: 'remix:Logos/webhook-line',
        hoverIcon: 'remix:Logos/webhook-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.integrations',
        route: '/integrations',
        section: Sections.Integrations,
        restricted: false,
        icon: 'remix:Development/puzzle-2-line',
        hoverIcon: 'remix:Development/puzzle-2-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.widgets',
        route: '/widgets',
        section: Sections.Widgets,
        restricted: false,
        featureFlag: WIDGETS_FLAG,
        icon: 'outlined:ring_volume',
        hoverIcon: 'filled:ring_volume',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.shop',
        route: '/shop',
        section: Sections.Shop,
        restricted: false,
        icon: 'remix:Finance/shopping-bag-4-line',
        hoverIcon: 'remix:Finance/shopping-bag-4-fill',
        routerLinkActiveOptions: { exact: false },
      },
      {
        type: 'link',
        label: 'menu.settings',
        route: '/settings',
        section: Sections.Settings,
        restricted: false,
        icon: 'remix:System/settings-6-line',
        hoverIcon: 'remix:System/settings-6-fill',
        routerLinkActiveOptions: { exact: false },
      },
    ]);
  }
}
